import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/white_trans_logo.png";
import { ReactComponent as FootballIcon } from "../../assets/football.svg";
import { UserContext } from "../UserContext";

const Sidebar: React.FC = () => {
  const { setSession } = useContext(AuthContext);
  const [selected, setSelected] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const user = useContext(UserContext).user;
  const isAdmin = user?.role === "ADMIN";

  const handleLogout = () => {
    setSession(null);
    navigate("/");
  };

  useEffect(() => {
    const pathToIndexMap: { [key: string]: number } = {
      "my-team": 0,
      matches: 1,
      refereeing: 2,
      profile: 3,
      settings: 4,
    };
    if (isAdmin) {
      pathToIndexMap["seasons"] = 5;
    }

    const matchedKey = Object.keys(pathToIndexMap).find((key) =>
      location.pathname.includes(key)
    );

    setSelected(matchedKey ? pathToIndexMap[matchedKey] : 0);
  }, [location.pathname]);

  const elements = [
    //  {
    //     titel: "Dashboard",
    //     link: ".",
    //     icon: (isActive: boolean) => (
    //       <svg
    //         className={`w-5 h-5 transition duration-75 ${
    //           isActive
    //             ? "text-gray-900"
    //             : "text-gray-500 group-hover:text-gray-900"
    //         }`}
    //         aria-hidden="true"
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="currentColor"
    //         viewBox="0 0 22 21"
    //       >
    //         <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
    //         <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
    //       </svg>
    //     ),
    //   },
    {
      titel: "My Team",
      link: "my-team",
      icon: (isActive: boolean) => (
        <svg
          className={`w-5 h-5 transition duration-75 ${
            isActive
              ? "text-gray-900"
              : "text-gray-500 group-hover:text-gray-900"
          }`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z" />
        </svg>
      ),
    },
    {
      titel: "Matches",
      link: "matches",
      icon: (isActive: boolean) => (
        <FootballIcon
          className={`w-5 h-5 transition duration-75 ${
            isActive
              ? "text-gray-900"
              : "text-gray-500 group-hover:text-gray-900"
          }`}
        />
      ),
    },
    {
      titel: "Refereeing",
      link: "refereeing",
      icon: (isActive: boolean) => (
        <FootballIcon
          className={`w-5 h-5 transition duration-75 ${
            isActive
              ? "text-gray-900"
              : "text-gray-500 group-hover:text-gray-900"
          }`}
        />
      ),
    },

    {
      titel: "Profile",
      link: "profile",
      icon: (isActive: boolean) => (
        <svg
          className={`w-5 h-5 transition duration-75 ${
            isActive
              ? "text-gray-900"
              : "text-gray-500 group-hover:text-gray-900"
          }`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      titel: "Settings",
      link: "settings",
      icon: (isActive: boolean) => (
        <svg
          className={`w-5 h-5 transition duration-75 ${
            isActive
              ? "text-gray-900"
              : "text-gray-500 group-hover:text-gray-900"
          }`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 0 1 6.126 3.537ZM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536ZM10.878 17.13c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.252 5.252 0 0 1-6.126 3.539Z" />
          <path
            fillRule="evenodd"
            d="M21 12.75a.75.75 0 1 0 0-1.5h-.783a8.22 8.22 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8.24 8.24 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8.188 8.188 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.36 8.36 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.29 8.29 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8.243 8.243 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8.222 8.222 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268c.197.417.428.816.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.332 8.332 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8.19 8.19 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.29 8.29 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503c.261-.375.492-.774.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267c.115-.439.195-.892.237-1.356h.784Zm-2.657-3.06a6.744 6.744 0 0 0-1.19-2.053 6.784 6.784 0 0 0-1.82-1.51A6.705 6.705 0 0 0 12 5.25a6.8 6.8 0 0 0-1.225.11 6.7 6.7 0 0 0-2.15.793 6.784 6.784 0 0 0-2.952 3.489.76.76 0 0 1-.036.098A6.74 6.74 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005a6.704 6.704 0 0 0 2.18.798l.022.003a6.792 6.792 0 0 0 2.368-.004 6.704 6.704 0 0 0 2.205-.811 6.785 6.785 0 0 0 1.762-1.484l.009-.01.009-.01a6.743 6.743 0 0 0 1.18-2.066c.253-.707.39-1.469.39-2.263a6.74 6.74 0 0 0-.408-2.309Z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
    {
      titel: "Seasons",
      link: "seasons",
      icon: (isActive: boolean) => (
        <svg
          className={`w-5 h-5 transition duration-75 ${
            isActive
              ? "text-gray-900"
              : "text-gray-500 group-hover:text-gray-900"
          }`}
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path d="M3 5h18a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" />

          <path d="M3 10h18" />

          <path d="M8 2v4" />

          <path d="M16 2v4" />
        </svg>
      ),
    },
  ];

  return (
    <div className="flex flex-row">
      {/* Sidebar */}
      <aside id="default-sidebar" className="w-64 h-full bg-white">
        <div className="h-full px-3 py-4 overflow-y-auto">
          <ul className="space-y-2 font-medium">
            <li className="pt-2 ps-3 pb-4 rounded-xl hover:bg-gray-100 flex justify-start group ">
              <Link to="/">
                <img
                  src={logo}
                  alt="Logo"
                  className="h-[60px] filter invert group opacity-70 group-hover:opacity-100"
                />
              </Link>
            </li>
            {elements
              .filter((e) => !(e.titel === "Seasons") || isAdmin)
              .map((e, index) => {
                const isActive = index === selected;
                return (
                  <li key={index}>
                    <Link
                      to={e.link}
                      className={`flex items-center p-2 text-gray-900 rounded-lg group ${
                        isActive ? "bg-gray-100" : "hover:bg-gray-100"
                      }`}
                    >
                      {e.icon(isActive)}
                      <span className="ms-3">{e.titel}</span>
                    </Link>
                  </li>
                );
              })}

            <li key="logout-button">
              <button
                onClick={handleLogout}
                className="flex items-center p-2 w-full text-gray-900 rounded-lg border border-red-200 hover:bg-red-100 group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2.5}
                  stroke="currentColor"
                  className="w-5 h-5 text-gray-500 transition duration-75  group-hover:text-gray-900 "
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
                  />
                </svg>
                <span className="ms-3">Logout</span>
              </button>
            </li>
          </ul>
        </div>
      </aside>
    </div>
  );
};

export default Sidebar;
